/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'goal-fields.goal-followers.add-followers-title': 'Añadir seguidores',
  'goal-fields.goal-followers.title': 'Seguidores',
  'goal-fields.goal-links.add-parent-goal-title': 'Añadir una meta principal',
  'goal-fields.goal-links.edit-parent-goal-title': 'Editar meta principal',
  'goal-fields.goal-links.unlink-parent-goal-title': 'Desvincular meta principal',
  'goal-fields.goal-metrics.automatic-metric-title': 'De las submetas',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.remove-label': 'Eliminar',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.settings-label': 'Configuración',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.show-more': 'Mostrar más',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.update-value-label': 'Actualizar valor',
  'goal-fields.goal-metrics.manual-metrics-popup-content.start-value-label': 'Inicio:',
  'goal-fields.goal-metrics.manual-metrics-popup-content.target-value-label': 'Objetivo:',
  'goal-fields.goal-metrics.metrics-popup.external-metric-description':
    'El progreso se rellena automáticamente con {compass}. Esta métrica de metas solo se puede editar en {compass}.',
  'goal-fields.goal-metrics.no-metrics-instructions': 'Ve a la página de metas completa para cambiar este campo',
  'goal-fields.goal-metrics.no-metrics-title': 'Sin métrica',
  'goal-fields.goal-metrics.open-in-new-window-label': 'Abrir en otra ventana',
  'goal-fields.goal-metrics.percentage-metric-completion-percentage.description': 'progreso realizado',
  'goal-fields.goal-metrics.rollup-metric-title-no-sub-goals': 'Ninguna submeta con métricas conectadas',
  'goal-fields.goal-metrics.title': 'Progreso',
  'goal-fields.goal-owner.title': 'Propietario',
  'goal-fields.goal-start-date.add-start-date-title': 'Añadir fecha de inicio',
  'goal-fields.goal-start-date.cancel-button': 'Guardar',
  'goal-fields.goal-start-date.creation-date': 'Esta meta se creó el {creationDate}',
  'goal-fields.goal-start-date.edit-start-date-label': 'Editar fecha de inicio de la meta',
  'goal-fields.goal-start-date.enter-start-date-title': 'Introducir fecha de inicio',
  'goal-fields.goal-start-date.open-calendar-label': 'Abrir calendario',
  'goal-fields.goal-start-date.title': 'Fecha de inicio',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-in-progress': 'En progreso',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-more-button': 'Más estados',
  'goal-fields.goal-status-picker.goal-status-okr-current-status': '¿Cuál es el estado actual?',
  'goal-fields.goal-status-picker.goal-status-okr-help-content':
    '¿Pones en práctica los objetivos y resultados clave? <link>Descubre cómo usar las metas para ello</link>',
  'goal-fields.goal-status-picker.goal-status-okr-help-info-icon-label': 'Enlace de ayuda',
  'goal-fields.goal-status.archived': 'Archivado',
  'goal-fields.goal-status.at-risk': 'En riesgo',
  'goal-fields.goal-status.cancelled': 'Cancelado',
  'goal-fields.goal-status.completed': 'Completados 🎉',
  'goal-fields.goal-status.off-track': 'No según lo previsto',
  'goal-fields.goal-status.on-track': 'Según lo previsto',
  'goal-fields.goal-status.paused': 'En pausa',
  'goal-fields.goal-status.pending': 'Pendiente',
  'goal-fields.goal-status.title': 'Estado',
  'goal-fields.goal-sub-goals.add-sub-goals-title': 'Añadir submetas',
  'goal-fields.goal-sub-goals.unlink-sub-goal-tooltip': 'Desvincular submeta',
  'goal-fields.goal-tags.add-tags-title': 'Añade etiquetas',
  'goal-fields.goal-tags.title': 'Etiquetas',
  'goal-fields.goal-target-date.picker-placeholder': 'Pendiente',
  'goal-fields.goal-target-date.title': 'Fecha prevista',
  'goal-fields.goal-type.goal': 'Meta',
  'goal-fields.goal-type.key-result': 'Resultado clave',
  'goal-fields.goal-type.objective': 'Objetivo',
  'goal-fields.goal-type.title': 'Tipo',
  'goal-fields.parent-goal.title': 'Meta principal',
  'goal-fields.sub-goals.title': 'Submetas',
  'goal-fields.teams.add-teams-title': 'Añade equipos',
  'goal-fields.teams.follow-team': 'Seguir al equipo',
  'goal-fields.teams.remove-team': 'Eliminar equipo',
  'goal-fields.teams.search-team-placeholder': 'Busca un equipo',
  'goal-fields.teams.show-more': 'Mostrar más',
  'goal-fields.teams.title': 'Equipos',
  'goal-fields.teams.verified-team-label': 'Equipo verificado',
  'goal-fields.teams.view-profile': 'Ver perfil',
  'goal-fields.use-goal-flags.generic-error-description': 'Algo ha ido mal. Inténtalo de nuevo en unos minutos.',
  'goal-fields.use-goal-flags.generic-error-title': 'Se ha producido un error',
  'goal-fields.use-goal-flags.goal-owner-change-error-header': 'Error al cambiar el propietario de la meta',
  'goal-fields.use-goal-flags.goal-tags-add-failure-title': 'No se ha podido añadir la etiqueta',
  'goal-fields.use-goal-flags.goal-tags-create-failure-title': 'No se ha podido crear la etiqueta',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-description':
    'El nombre que has introducido para la etiqueta es demasiado largo. Introduce un nombre con 255 caracteres o menos.',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-title': 'No se ha podido crear la etiqueta',
  'goal-fields.use-goal-flags.goal-tags-remove-failure-title': 'No se ha podido eliminar la etiqueta',
  'goal-fields.use-goal-flags.goal-teams-add-failure-title': 'Error al añadir el equipo; vuelve a intentarlo',
  'goal-fields.use-goal-flags.goal-teams-remove-failure-title': 'Error al eliminar el equipo; vuelve a intentarlo',
  'goal-fields.use-goal-flags.parent-goal-change-error-header': 'No se ha podido cambiar la meta principal',
  'goal-fields.use-goal-flags.start-date-change-error-header': 'No se ha podido cambiar la fecha de inicio',
  'goal-fields.use-goal-flags.target-date-change-error-header': 'No se ha podido cambiar la fecha objetivo',
  'townsquare.goal-fields.tag': 'Eliminar etiqueta',
  'townsquare.goal-fields.tooltip-usage-count':
    '{usageCount, plural, one {En uso en {usageCount,number} lugar} other {En uso en {usageCount,number} lugares}}',
};
